import { useAppSelector } from "app/hooks";
import { selectCurrentPractice } from "features/auth/auth-slice";

// The single gate for every voice surface (softphone, click-to-call, /calls,
// Settings → Voice, incoming-call pops): the practice's Voice Setup
// activation, `Practice.voice_enabled`. No feature flag is involved
// (SN-19621) — a practice without the calling subscription sees nothing.
export default function usePracticeVoiceEnabled(): boolean {
  const currentPractice = useAppSelector(selectCurrentPractice);
  return Boolean(currentPractice?.voice_enabled);
}
